<div class="llama31-dialog">
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/logos/meta.svg" alt="Meta Llama Logo" class="mini-logo" />
    <h2>Llama&nbsp;3.1</h2>
    <div class="sub">Open-weight instruction model — practical, scalable, and deployment-friendly</div>
  </div>

  <div class="body">
    <p>
      <strong>Llama&nbsp;3.1</strong> is Meta’s widely adopted open-weight model family built for reliable
      instruction following, strong general reasoning, and production-ready performance. It’s a great choice
      when you want predictable outputs, cost control, and the flexibility to run or fine-tune models in your
      own environment.
    </p>

    <ul>
      <li><strong>Open deployment flexibility:</strong> run on your infra, cloud, or managed platforms with control over latency and cost.</li>
      <li><strong>Strong instruction following:</strong> dependable “do exactly this” behavior for business workflows and structured tasks.</li>
      <li><strong>Solid reasoning baseline:</strong> performs well across everyday analysis, summarization, and general Q&amp;A.</li>
      <li><strong>Developer-friendly outputs:</strong> clear formatting, consistent tone, and useful code + explanation balance.</li>
      <li><strong>RAG-ready behavior:</strong> pairs well with retrieval pipelines to stay grounded in your own documents and data.</li>
    </ul>

    <div class="optimal">
      <h3>What it’s used for</h3>
      <ul>
        <li>Everyday enterprise assistants: internal Q&amp;A, policy help, and workflow copilots</li>
        <li>Summarization and transformation: emails, meeting notes, tickets, PRDs, and docs</li>
        <li>Support tooling: customer help drafts, macros, and consistent knowledge responses</li>
        <li>Developer tasks: code generation, refactors, reviews, and quick technical explanations</li>
        <li>RAG and search assistants: grounded answers based on your connected sources</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Best when to use Llama&nbsp;3.1</h3>
      <ul>
        <li>You want <strong>open-weight flexibility</strong> and the option to deploy privately or customize later</li>
        <li>You need <strong>predictable instruction following</strong> for repeatable business operations</li>
        <li>You’re building <strong>RAG assistants</strong> that must stay anchored to internal documents</li>
        <li>You care about <strong>cost / latency control</strong> at scale</li>
        <li>You want a strong “default model” for <strong>general productivity</strong> across teams</li>
      </ul>
    </div>
  </div>
</div>
